import React from 'react';
import FormSection from '../../../../components/atom/FormSection';
import FormikInput from '../../../../components/atom/FormikInput';

export default function ClientEditHotjar() {
    return (
        <FormSection title="Hotjar integration">
            <FormikInput name="hotjarid" label="Hotjar ID" />
            <FormikInput name="hotjarsv" label="Hotjar Snippet Version" />
        </FormSection>
    );
}
